module.exports = __webpack_public_path__ + "img/9788949120713.ff55511e.jpg";